// This file is auto-generated by @hey-api/openapi-ts

export const CustomerProfileApplicationStatesEnum = {
    PROCESSED: 'PROCESSED',
    REJECTED: 'REJECTED',
    UNCHECKED_DATA: 'UNCHECKED_DATA'
} as const;

export type CustomerProfileApplicationStatesEnum = typeof CustomerProfileApplicationStatesEnum[keyof typeof CustomerProfileApplicationStatesEnum];
